import { Avatar, List } from "antd";
import { InterviewSchedule } from "../../../Entities/interview-schedule.entity";

interface ParticipantsProps {
  schedule: InterviewSchedule;
}

type Participant = {
  name: string;
  type: string;
};

const Participants: React.FC<ParticipantsProps> = ({ schedule }) => {
  const participants: Participant[] = [];

  // Add organizer if available
  if (schedule?.participants && schedule.participants.length > 0) {
    participants.push({
      name: schedule.participants[0].name || "Organizer",
      type: "Organizer",
    });
  }

if (schedule?.user) {
  const firstName = schedule.user.firstName ?? "";
  const lastName = schedule.user.lastName ?? "";
  const name =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : firstName || lastName || "Candidate";

  participants.push({
    name,
    type: "Candidate",
  });
}

  // Add interview guests if available
  if (schedule?.interviewGuests && schedule.interviewGuests.length > 0) {
    schedule.interviewGuests.forEach((guest: string) => {
      if (guest) {
        participants.push({
          name: guest,
          type: "Guest",
        });
      }
    });
  } else {
    // If no interview guests are available, add a placeholder
    participants.push({
      name: "Interview Panel",
      type: "Guest",
    });
  }

  return (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={participants}
      style={{ marginBottom: 0, marginLeft: 0 }}
      renderItem={(participant, index) => (
        <List.Item style={{ marginBottom: 0, marginLeft: 0 }}>
          <List.Item.Meta
            avatar={
              <Avatar
                style={
                  {
                    // backgroundColor: getRandomColor(),
                    // color: "white",
                  }
                }
              >
                {participant?.name?.charAt(0)}
              </Avatar>
            }
            title={
              <p style={{ textTransform: "capitalize", margin: 0 }}>
                {participant.name}
              </p>
            }
            description={participant?.type}
          />
        </List.Item>
      )}
    />
  );
};

export default Participants;
